<template>
    <div>
        <div id="page">
            <div class="hd-bg">
            <div class="header">
                <div class="left"><div class="city" @click="showCity = true">{{ activeCity }}</div></div>
                <div class="right">
                    <a href="javascript:;" class="btn tel" @click="telConfirm"></a>
                    <router-link v-if="logined == true" to="UserCenter" class="btn user"></router-link>
                    <router-link v-else-if="logined == false" to="login" class="btn user"></router-link>
                </div>
                <div class="center"><router-link to="/">
				{{isshowlogin?'址点楼盘':'选址中国'}}
				
				</router-link></div>
            </div>
        </div>
        <div class="banner">
            <van-swipe :autoplay="3000" indicator-color="white">
                <van-swipe-item v-for="item in bannerImg"><a class="item" :href="item.link"><img class="img" :src="item.img" alt=""></a></van-swipe-item>
            </van-swipe>
            <div class="banner-so">
                <input class="inp" type="text" placeholder="Search" v-model="searchKey" />
                <router-link class="btn" :to="{path: 'searchResult', query: {key: searchKey}}"></router-link>
            </div>
        </div>
        <div class="nav">
            <router-link to="PropertyList" ><img src="../assets/images/icon-nav-01.png" alt="" class="icon">楼盘</router-link>
            <router-link to="HouseList" ><img src="../assets/images/icon-nav-02.png" alt="" class="icon">房源</router-link>
            <router-link to="Development" ><img src="../assets/images/icon-nav-03.png" alt="" class="icon">开发区</router-link>
            <router-link to="NewsList" ><img src="../assets/images/icon-nav-04.png" alt="" class="icon">资讯</router-link>
           <router-link v-if="!isshowlogin" to="Question" ><img src="../assets/images/icon-nav-05.png" alt="" class="icon">问答</router-link>
            <router-link to="ListUser" ><img src="../assets/images/icon-nav-06.png" alt="" class="icon">经纪人</router-link>
            <router-link v-if="logined == true" to="PublishCommission" ><img src="../assets/images/icon-nav-07.png" alt="" class="icon">委托</router-link>
            <router-link v-else to="login" ><img src="../assets/images/icon-nav-07.png" alt="" class="icon">委托</router-link>
            <router-link v-if="logined" to="UserCenter"><img src="../assets/images/icon-nav-08.png" alt="" class="icon">个人中心</router-link>
            <router-link v-if="!logined" to="login"><img src="../assets/images/icon-nav-08.png" alt="" class="icon">个人中心</router-link>
        </div>
        <dl class="headline">
            <dt>选址头条</dt>
            <dd>
                <div class="content">
                    <div class="content__container">
                        <div v-if="hasdata" id="anrun" class="content__container__list">
                            <div  class="content__container__list__item" v-for="item in headLine">
                                <router-link :to="{path: 'DetailInfoView', query:{id:item.info_id}}"><span>{{ item.title }}</span></router-link>
                            </div> 
                        </div>
                           
                    </div>
                </div>
            </dd>
        </dl>
        <div class="nav2">
            <router-link to="PropertyList" class="item s1">区域</router-link>
            <router-link to="PropertyList" class="item s2">面积</router-link>
            <router-link to="PropertyList" class="item s3">价格</router-link>
        </div>
        <div class="gridw01" v-if="advertisingList.length > 0">
            <div class="gridw01-tit">精彩推荐</div>
            <ul class="list-w1" v-if="advertisingList.length">
                <li v-for="(item, index) in advertisingList" :key="index">
                    <router-link :to="item.link" class="list-w1-item" :data-id="item.push_id">
                        <div class="list-w1-pic">
                            <img :src="item.img" alt="">
                            <h5 v-if="item.title" class="list-w1-tit">
                                <div class="h5inner">{{ item.title }}</div>
                            </h5>
                        </div>
                    </router-link>
                </li>
            </ul>
        </div>
        <div class="gridw01" v-if="buildingPushList.length > 0">
            <div class="gridw01-tit">热门楼盘</div>
            <ul class="list-w2">
                <li v-for="(item, index) in buildingPushList" :key="index">
                    <div class="list-w2-item">
                        <router-link :to="{path:'Property',query:{id:item.building_id}}" class="list-w2-item">
                            <div class="list-w2-pic">
                                <div class="tags">{{ item.lable }}</div>
                                <img :src="item.main_img" alt="" class="bg">
                                <div class="txt">
                                    <div class="tit">{{ item.building_name }}</div>
                                    <div class="addr">{{ item.address }}</div>
                                </div>
                            </div>
                        </router-link>
                        <div class="list-w2-info">
                            <div class="price">{{ item.rent_sale_price }}{{ rent_sale_price_danwei[item.rent_sale_price_danwei] }}</div>
                            <div class="info"><span v-for="sub in item.labels"><router-link :to="{path: 'searchResult', query: {key: sub.label}}">{{ sub.label }}</router-link></span></div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <router-link to="PropertyList" class="btn-block" v-if="buildingPushList.length > 0"><span>更多楼盘</span></router-link>
        <div class="gridw01" v-if="housePushList.length > 0">
            <div class="gridw01-tit">热门房源</div>
            <ul class="list-w2">
                <li v-for="(item, index) in housePushList" :key="index">
                    <div class="list-w2-item">
                        <router-link :to="{path:'house',query:{id:item.house_id}}" class="list-w2-item">
                            <div class="list-w2-pic">
                                <div class="tags">{{ item.lable }}</div>
                                <img :src="item.main_img" alt="" class="bg">
                                <div class="txt">
                                   
                                    <div class="tit">{{ item.house_name }}</div>
                                     <div class="addr">{{ item.address }}</div>
                                </div>
                            </div>
                        </router-link>
                        <div class="list-w2-info">
                            <div class="price">{{ item.rent_sale_price }}{{ rent_sale_price_danwei[item.rent_sale_price_danwei] }}</div>
                            <div class="info"><span v-for="sub in item.labels"><router-link :to="{path: 'searchResult', query: {key: sub.label}}">{{ sub.label }}</router-link></span></div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <router-link to="PropertyList" class="btn-block" v-if="housePushList.length > 0"><span>更多房源</span></router-link>
        <div class="gridw01" v-if="developmentZoneList.length > 0">
            <div class="gridw01-tit">开发区</div>
            <ul class="list-w2 ss">
                <li v-for="(item, index) in developmentZoneList" :key="index">
                    <router-link :to="{path: 'developmentDetail', query: {id: item.development_zone_id}}" class="list-w2-item">
                        <div class="list-w2-pic">
                            <img :src="item.thumbnail" alt="" class="bg">
                            <div class="txt">
                               
                                <div class="tit">{{ item.zone_name }}</div>
                                 <div class="addr">{{ item.address }}</div>
                            </div>
                        </div>
                    </router-link>
                </li>
            </ul>
        </div>
        <router-link to="Development" class="btn-block" v-if="developmentZoneList.length > 0"><span>更多开发区</span></router-link>
        <div class="so-index">
            <div class="cont" :style="'background-image: url('+ soImg +')'">
                <input class="inp" type="text" v-model="fastName" placeholder="请输入姓名">
                <input class="inp" type="text" v-model="fastTel" placeholder="请输入手机号">
                <input class="btn" type="button" value="马上找房" @click="fastDelegate">
            </div>
        </div>
        <div ref="points3" class="gridw01" v-if="todayArticle.length > 0">
            <div class="gridw01-tit">今日资讯</div>
            <div class="gridw01-bd">
                <router-link :to="{path: 'DetailInfoView', query: {id: item.info_id}}" class="listw02-item" v-for="(item, index) in todayArticle" :key="index">
                    <div class="listw02-item-pic"><img class="mimg" :src="item.thumbnail" alt=""></div>
                    <div class="listw02-item-txt">
                        <div class="listw02-item-name">{{ item.title }}</div>
                        <div class="listw02-item-info"><span>{{ item.author }}</span><span>{{ item.create_time }}</span></div>
                    </div>
                </router-link>
            </div>
        </div>
        <router-link to="NewsList" class="btn-block" v-if="todayArticle.length > 0"><span>更多资讯</span></router-link>
        </div>
        <Footer></Footer>

        <van-popup v-model="showCity" position="bottom" :overlay="true">
            <van-picker show-toolbar :columns="cityList" value-key="name"  @cancel="showCity = false" @confirm="onConfirm" />
        </van-popup>
    </div>
</template>

<script>

    import Footer from '@/components/Footer'
    import { Popup, Picker, Dialog, Swipe, SwipeItem, NoticeBar, Toast } from 'vant'
    import Swiper from 'swiper'
    import 'swiper/dist/css/swiper.css';
    import wx from 'weixin-js-sdk'
	import {mapState} from 'vuex'
    export default {
        data: function () {
            return {
				isshowlogin:true,
                hasdata:false,
                logined: false,
                showCity: false,
                
                rent_sale_price_danwei: this.$store.getters.rent_sale_price_danwei,
                downPath: this.api.downPath,
                
                bannerImg: [],
                soImg: require('../assets/images/bg-01.jpg'),
                headLine: [],
                advertisingList: [],
                buildingPushList: [],
                housePushList: [],
                todayArticle: [],
                developmentZoneList: [],
                searchKey: '',
                fastName: '',
                fastTel: ''
            }
        },
        components: {
            Footer,
            Swiper,
            [Popup.name]: Popup,
            [Picker.name]: Picker,
            [Dialog.name]: Dialog,
            [Swipe.name]: Swipe,
            [SwipeItem.name]: SwipeItem,
            [NoticeBar.name]: NoticeBar,
            [Toast.name]: Toast
        },
		computed:{
			...mapState(['cityList','activeCity'])
		},
        mounted() {
			this.$store.dispatch("getaddress")
            //this.getHeaderInfo();
            this.getHomeInfo();
            
            this.$nextTick(function () {
                //this.headline();
            })
            this.checkLogined();
            this.getShareConfig()
			this.isshowlogin=swan.webView.getEnv().smartprogram
        },
        methods: {
            getShareConfig(){
                const _this = this;
                _this.api.getShareConfig({
                    url: window.location.href.split('#')[0],
                    target: 'Home'
                }).then(function(response){
                    const result = response;
                    wx.config({
                        debug: false,
                        appId: result.appId,
                        timestamp: result.timestamp,
                        nonceStr: result.nonceStr,
                        signature: result.signature,
                        jsApiList: [
                            'updateAppMessageShareData',
                            'updateTimelineShareData',
                            'onMenuShareAppMessage',//老版本分享接口。
	                        'onMenuShareTimeline'//老版本分享
                        ]
                    });
                    var link = '';
                    var u = navigator.userAgent, app = navigator.appVersion;
                    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
                    var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
                    if (isAndroid) {
                        link = window.location.href.split('#')[0] + '?#' + window.location.href.split('#')[1]
                    }
                    if (isIOS) {
                        link = window.location.href.split('#')[0] + '#' + window.location.href.split('#')[1]
                    }
                    wx.error(function (res) {
                        console.log('验证失败返回的信息:',res.errMsg);
                    });
                   
                    wx.ready(function () {
                        const imgUrl = 'http://www.xuanzhizhongguo.com/images/logo_share.png'
                        // 分享给朋友
                        wx.updateAppMessageShareData({
                            title:'企业选址上选址中国/办公楼/产业园/厂房-选址中国', // 分享标题
                            desc: '网址（m.xuanzhizhongguo.com）', // 分享描述
                            link: link,
                            imgUrl: imgUrl,
                            // imgUrl: 'http://www.xuanzhizhongguo.com/uploads/avatar/15577990642478.jpg', // 分享图标
                            success: function () {
                                console.log(wx)
                            }
                        });

                        // 分享到朋友圈
                        wx.updateTimelineShareData({
                             title:'企业选址上选址中国/办公楼/产业园/厂房-选址中国', // 分享标题
                            desc: '网址（m.xuanzhizhongguo.com）', // 分享描述
                            link: link,
                            imgUrl: imgUrl,
                            success: function () {
                                
                            }
                        });
                    });
                })
            },
            checkLogined () {
                var _this = this;
                _this.api.getUserInfo().then(function(response){
                    if (response.status == 1) {
                        _this.logined = true
                    } else {
                        _this.logined = false
                    }
                })
            },
            getHeaderInfo () {
                var _this = this;
                _this.api.getCityInfo().then(function(response){
                    _this.cityList = response;
                    console.log(_this.$store.state)
                    if (_this.$store.getters.activeAddr == null) {
                        _this.$store.commit('changeActiveAddr', response[0]);
                    }
                    _this.activeCity = _this.$store.getters.activeAddr.name;
                })
            },
            headline3 () {
                alert(6)
                let speed = 820;        //数字越大滚得越慢
                var tab = document.getElementById("demo");
                var tab1 = document.getElementById("demo1");
                var tab2 = document.getElementById("demo2");
                console.log(tab,tab1,tab2)
                tab2.innerHTML = tab1.innerHTML;
                tab.scrollTop = tab1.offsetHeight;
                function Marquee(){
                if (tab.scrollTop >= tab1.offsetHeight) {
                    tab.scrollTop-=tab2.offsetHeight;
                }else{
                    tab.scrollTop+=1;
                }
                }
                var MyMar=setInterval(Marquee,speed);
                // let mySwiper = new Swiper ('.headline .swiper-container', {
                //     loop: true,
                //     direction: 'vertical',
                //     speed: 600,
                //     observer:true,
                //     effect: 'fade',
                //     autoplay: {
                //         delay: 5000
                //     }
                // });
            },
            onConfirm (value, index) {
                this.showCity = false;
                this.$store.commit('changeActiveAddr', this.cityList[index]);
				this.$store.commit('setActiveAddr', this.cityList[index].name);
                //this.activeCity = this.$store.getters.activeAddr.name;
            },
            telConfirm () {
                Dialog.confirm({
                    title: '400转接',
                    message: '',
                    confirmButtonText: '确定'
                }).then(() => {
                    window.location.href = "tel:4000080960";
                });
            },
            getHomeInfo: function(){
                const _this = this;
                _this.api.getHomeInfo().then(function(response){
                   
                   
                    
                    _this.headLine = response.news_article_list;
                     _this.hasdata=true
                    _this.$nextTick(()=>{
                         document.getElementById("anrun").style.animationPlayState="running"
                    })
                    _this.advertisingList = response.advertisingList;
                    _this.buildingPushList = response.buildingPushList;
                    _this.housePushList = response.housePushList;
                    _this.todayArticle = response.todayArticle;
                    _this.developmentZoneList = response.developmentZoneList;
                    _this.bannerImg = response.slideshowList;
                    for (let i in _this.todayArticle) {
                        _this.todayArticle[i].create_time = _this.formatTime(_this.todayArticle[i].create_time, '{y}-{m}-{d}');
                    }
                })
            },
            fastDelegate(){
                const _this = this;
                let params = new FormData();
                if (_this.fastName == '') {
                    Toast('请输入姓名');
                } else if (_this.fastTel == '') {
                    Toast('请输入手机号');
                } else {
                    params.append('name', _this.fastName);
                    params.append('mobile', _this.fastTel);
                    params.append('type', 'entrust');
                    _this.api.fastDelegate(params).then(function(response){
                        Toast(response.msg)
                        _this.fastName =''
                        _this.fastTel = ''
                    })
                }
            }
        }
    }
</script>

<style scoped>
    .content {
  position: relative;
  height: 4rem;
  overflow: hidden;
  font-size:.27rem;
}
.content__container {
  overflow: hidden;
  height: .4rem;
}
.content__container__list__item {
  height: .4rem;
  margin: 0;
}
.content__container__list__item a {
  height: .4rem;
  display:block;
}


.content__container__list {
  margin-top: 0;
  animation-play-state: paused;
  -webkit-animation-play-state: paused;
  text-align: left;
  list-style: none;
  -webkit-animation-name: change;
  -webkit-animation-duration: 20s;
  -webkit-animation-iteration-count: infinite;
  animation-name: change;
  animation-duration: 20s;
  animation-iteration-count: infinite;
}



@keyframes change {
 
  0% {
    -webkit-transform: translate3d(0, 10%, 0);
    transform: translate3d(0, 10%, 0);
  }
  10% {
    -webkit-transform: translate3d(0, 0%, 0);
            transform: translate3d(0, 0%, 0);
  }
  20% {
    -webkit-transform: translate3d(0, -10%, 0);
            transform: translate3d(0, -10%, 0);
  }
  30% {
    -webkit-transform: translate3d(0, -20%, 0);
            transform: translate3d(0, -20%, 0);
  }
  40% {
    -webkit-transform: translate3d(0, -30%, 0);
            transform: translate3d(0, -30%, 0);
  }
  50% {
    -webkit-transform: translate3d(0, -40%, 0);
            transform: translate3d(0, -40%, 0);
  }
  60% {
    -webkit-transform: translate3d(0, -50%, 0);
            transform: translate3d(0, -50%, 0);
  }
  70% {
    -webkit-transform: translate3d(0, -60%, 0);
            transform: translate3d(0, -60%, 0);
  }
  80% {
    -webkit-transform: translate3d(0, -70%, 0);
            transform: translate3d(0, -70%, 0);
  }
  
  90% {
    -webkit-transform: translate3d(0, -80%, 0);
            transform: translate3d(0, -80%, 0);
  }
   100% {
    -webkit-transform: translate3d(0, -90%, 0);
            transform: translate3d(0, -90%, 0);
  }
 
}


    .h5inner{
        width:100%!important;
        text-overflow: ellipsis!important;
        overflow: hidden!important;
        text-align:center;
        white-space:nowrap!important;
    }
    .list-w1-pic h5{
        font-weight:normal;
       
        display:flex;
        align-items:center;
        min-width:0;
    }
    .hd-bg {height: 1rem;}

    .header {
        position: fixed;top: 0;left: 0;width: 100%;height: 1rem;z-index: 80;
        background-color: #343434;line-height: 1rem;text-align: center;
    }
    .header .btn {
        display: inline-block;vertical-align: middle;width: .36rem;height: .36rem;margin: 0 .15rem;
        background-repeat: no-repeat;background-position: center center;-webkit-background-size: contain;background-size: contain;
    }
    .header .user {background-image: url('../assets/images/icon-head-user.png');}
    .header .tel {background-image: url('../assets/images/icon-head-tel.png');}
    .header .left {
        position: absolute;top: 0;left: .15rem;
    }
    .header .right {
        position: absolute;top: 0;right: .15rem;
    }
    .header .center {
        position: relative;
        display: inline-block;
        font-size: .36rem;color: #ffffff;
    }
    .header .city {
        color: #ffffff;font-size: .24rem;
        white-space: nowrap;margin-left: .1rem;
        padding-right: .3rem;background: url("../assets/images/icon-sel3.png") no-repeat right center;-webkit-background-size: .2rem;background-size: .2rem;
    }
    .banner {position: relative;background-color: #fff;padding-top: 56%;height: 0;}
    .banner .van-swipe {position: absolute;top: 0;left: 0;width: 100%;height: 100%;}
    .banner .item {display: block;position: relative;overflow: hidden;height: 100%;}
    .banner .img {position: absolute;top: 0;left: 0;height: 100%;width: 100%;}
    .banner-so {
        position: relative;width: 5.8rem;height: .8rem;margin: -.4rem auto 0;background-color: #ffffff;padding: 0 .1rem;
        -webkit-border-radius: .8rem;-moz-border-radius: .8rem;border-radius: .8rem;
        display: flex;justify-content: space-between;align-items: center;
        box-shadow: 0 .05rem .1rem .04rem rgba(57, 56, 54, 0.22);
    }
    .banner-so .btn {
        width: .6rem;height: .5rem;flex-shrink: 0;
        border: none;border-left: 1px solid #d9d9d9;
        background: transparent url('../assets/images/icon-so.png') no-repeat center center;-webkit-background-size: .32rem;background-size: .32rem;
    }
    .banner-so .inp {
        flex-grow: 1;border: none;padding: 0 .2rem;
    }
    .nav {
        background-color: #fff;padding: .6rem .1rem .2rem;
        display: flex;justify-content: start;align-items: center;flex-wrap: wrap;
    }
    .nav a {width: 25%;text-align: center;margin: .15rem 0;font-size: .24rem;color: #595757;}
    .nav .icon {
        display: block;margin: 0 auto .1rem;width: 1rem;height: 1rem;
    }
    .headline {background-color: #ffffff;margin-top: .2rem;height: .7rem;padding: .15rem .3rem;line-height: .4rem;}
    .headline dt {float: left;color: #ff6666;font-weight: bold;border-right: 1px solid #eeeeee;padding-right: .1rem;margin-right: .1rem;}
    .headline dd {overflow: hidden;white-space: nowrap;color: #595757;}
    .headline .swiper-container {height: .4rem;}

    .headline .swiper-slide a {display: block;background-color: #fff;overflow-x: auto;padding-bottom: 20px;margin-bottom: -20px;}
    .headline .swiper-slide-active span {
        
        
    }
    .van-notice-bar {background-color: #fff;height: auto;line-height: inherit;font: inherit;color: inherit;padding: 0;}
    .headline .swiper-slide a {flex-grow: 1;}
    .nav2 {padding: .2rem;display: flex;justify-content: space-between;align-items: center;}
    .nav2 .item {
        position: relative;display:flex;align-items:center;flex: 1 0;width: 33%;justify-content: center;height: .6rem;color: #ffffff;margin: 0 .1rem;
        -webkit-border-radius: .05rem;-moz-border-radius: .05rem;border-radius: .05rem;
    }
    .nav2 .item:before {
        content: '';position: absolute;top: 0;left: 0;width: 100%;height: 100%;
        background-image: -moz-linear-gradient( 135deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, .1) 100%);
        background-image: -webkit-linear-gradient( 135deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, .1) 100%);
        background-image: -ms-linear-gradient( 135deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, .1) 100%);
        background-image: linear-gradient( 135deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, .1) 100%);
    }
    .nav2 .item.s1 {background-color: #ff5a75;}
    .nav2 .item.s2 {background-color: #ffe931;}
    .nav2 .item.s3 {background-color: #00ede5;}
    .gridw01 {margin-bottom: .2rem;font-weight:bold;}
    .listw02-item:last-child {border: none;}
    
   
    

</style>
